import React, { useState, useEffect } from 'react';
import { css } from '@emotion/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { shadowLightStyle } from 'client/styles/common';

function ScrollerFixedHeader({ onClose, title }) {
    const [active, setActive] = useState(false);
    const [ref, setRef] = useState(null);
    const shouldShowCloseBtn = typeof onClose === 'function';

    useEffect(() => {
        if (ref !== null) {
            const options = {
                root: null,
                rootMargin: '0px',
                threshhold: 0
            };
            const handleScroll = entries => {
                for (let entry of entries) {
                    const spotIsVisible = entry.isIntersecting;
                    if (spotIsVisible) {
                        setActive(false);
                    } else {
                        setActive(true);
                    }
                }
            };
            const observer = new window.IntersectionObserver(handleScroll, options);
            observer.observe(ref);
            return () => observer.unobserve(ref);
        }
    }, [ref]);

    return (
        <>
            <div ref={setRef} />
            <div
                css={[
                    headerStyle,
                    active && css(shadowLightStyle),
                    shouldShowCloseBtn && css(`justify-content: space-between;`)
                ]}
            >
                <Typography variant="h6">{title}</Typography>
                {shouldShowCloseBtn && (
                    <IconButton size="small" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                )}
            </div>
        </>
    );
}

export default ScrollerFixedHeader;

const headerStyle = css`
    padding: 16px;
    margin-bottom: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 3;
`;
